export default {"src":"/_next/static/media/password-eye-open.bbdd904e.svg","height":16,"width":16};